import { render, staticRenderFns } from "./My.vue?vue&type=template&id=36dc2fc8&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&id=36dc2fc8&lang=scss&scoped=true&"
import style1 from "./My.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc2fc8",
  null
  
)

export default component.exports